<template>
  <component :is="getSection" class="is-content">
    <component :is="getContainer">
      <div class="columns">
        <div class="column" :class="getWidth">
          <div class="content" v-html="getText" />
        </div>
      </div>
    </component>
  </component>
</template>

<script setup lang="ts">
import Container from '~/components/Container/index.vue'
import DefaultSection from '~/components/DefaultSection/index.vue'
import type { ParagraphTextOnlyFragment } from '#graphql-operations'

const props = defineProps<ParagraphTextOnlyFragment>()

const { fieldListType } = defineBlokkli({
  bundle: 'text_only',
})

const getText = computed(() => {
  return props.text || ''
})

// TODO inject wrapper
const getContainer = computed(() => {
  if (fieldListType.value === 'sidebar') {
    return 'div'
  }
  return Container
})

const getSection = computed(() => {
  if (fieldListType.value === 'sidebar') {
    return 'div'
  }
  return DefaultSection
})

const getWidth = computed(() => {
  return getContainer.value === Container ? 'is-two-thirds-desktop' : ''
})
</script>
